export class User {

    constructor(
        public email: string,  // compiler automatically creates attributes for these, wow
        public password: string 
      ) {}

}
